/*  TWO COLUMNS WITH IMAGE ( https://tailwindui.com/components/marketing/sections/content-sections#component-39249d619dcd4a64f3089bf550369572 )  */

import React, { useRef, useState, useContext } from 'react'
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import FluidImage from "src/utils/FluidImage";
import Button from "src/components/Button";
import { TitleColour, BoldColour } from "src/utils/ColourUtilities";
import { PageContext } from 'src/utils/context'
import SetCookie from 'src/utils/SetCookie'
import PlayButton from "src/images/play_button.svg"

const TwoColumnsWithVideo = ({ blok }) => {

  const { setCtaReferrer, name } = useContext(PageContext);

  const vidRef = useRef(false);
    const [hide, setHide] = useState(false);
    const handlePlayVideo = () => {
        vidRef.current.play()
        setHide(true)
    }

    const handleClick = (value) => {
      setCtaReferrer(value);
      SetCookie(`gated_content_redirect_url=${blok.button_target.cached_url}`);
    };

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className={`${blok.grey_bg ? "bg-midgrey py-9 md:py-24" : "bg-white my-9 md:my-24"} overflow-hidden`}>
        <div
          className={`relative flex flex-col md:flex-row ${
            blok.flip_content ? "md:flex-row-reverse" : ""
          } items-center max-w-7xl mx-auto px-6 sm:px-6 lg:px-8`}
        >
          <div
            className={`w-full lg:w-3/5 ${
              blok.flip_content ? "md:ml-12" : "md:mr-12"
            }`}
          >
            <div className="relative text-base lg:max-w-none">
              <div className="relative z-10">
                  <video src={blok.cdn_video ? blok.cdn_video : blok.video.filename} type="video/mp4" preload="none" controls width="1920" height="1080" muted controlsList="nodownload" ref={vidRef} className="z-10 block w-full h-full object-cover">
                      Sorry, your browser doesn't support embedded videos.
                  </video>
              </div>
              <div onClick={handlePlayVideo} onKeyDown={handlePlayVideo} role="button" tabIndex="0" aria-label="playbutton" className={`absolute block z-10 top-0 left-0 w-full h-full object-cover cursor-pointer transition-all duration-500 ease-in-out focus:outline-none outline-none ${hide ? 'opacity-0 invisible' : 'opacity-100 visible'}`}>
                  <FluidImage className="z-10 block w-full h-full object-cover" image={blok.thumbnail} placeholder="https://via.placeholder.com/1280x720" />
                  <div className={`absolute z-20 top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 sm:h-24 h-16 sm:w-24 w-16 inset-0`}>
                      <PlayButton className="w-full h-full"/>
                  </div>
              </div>
            </div>
          </div>
          <div className="w-full lg:w-2/5">
            <div className="text-base mt-6 mb-7 md:mb-6 lg:my-0">
              <h2
                className={`font-display uppercase text-4xl leading-8 font-normal tracking-tight ${BoldColour(
                  blok.colour
                )} md:text-5xl`}
              >
                <RichText>{blok.title}</RichText>
              </h2>
              <h2
                className={`font-display uppercase text-4xl leading-8 font-normal tracking-tight ${TitleColour(
                  blok.colour
                )} md:text-5xl`}
              >
                <RichText>{blok.sub_title}</RichText>
              </h2>
            </div>
            <div className="mt-8 lg:mt-0">
              <div className="text-sm md:max-w-prose md:mx-auto lg:max-w-none">
                <div className="text-lg text-gray-500">
                  <RichText>{blok.intro_copy}</RichText>
                </div>
                <div className="mt-5 prose text-darkgrey mx-auto lg:max-w-none border-l-2 border-red">
                  <span className="text-sm pl-4 block">
                    <RichText>{blok.content}</RichText>
                  </span>
                </div>
                {blok.button_label &&
                  <Button
                    className="bg-red hover:bg-darkred mt-4 py-[20px]"
                    target={
                      // If not gated content
                      !blok.gated_content ? blok.button_target.cached_url
                      : '/gated-content/'
                    }
                    blank={blok.gated_content ? false : blok.button_target.linktype === 'asset' ? true : false}
                    onClick={
                      blok.gated_content
                        ? () => handleClick(`${name}`)
                        : ""
                    }
                  >
                    {blok.button_label}
                  </Button>
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default TwoColumnsWithVideo;
